require("./Welcome.marko.scss");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            activeInput: false,
            institution: false,
            subdomain: '',
            error: false,
            searching: false
        };
        GState.bind(this, [
            'user',
            'institution'
        ]);
        this.host = location.host.replace(window.Defaults.domainAddon + '.', '').replace(':6040', '');
    },
    onMount: function () {
        if (!this.state.user || this.state.institution)
            return;
        this.checkExistingInstitution();
    },
    onActiveInput: function (active) {
        this.state.activeInput = active;
    },
    onKeywords: function (e) {
        if (e.keyCode == 13)
            return this.onSearch();
        this.state.error = false;
        this.state.subdomain = e.target.value;
    },
    onSearch: async function () {
        if (!this.state.subdomain)
            return;
        this.state.searching = true;
        try {
            const {error, message, institution} = await Request(`/institution/retreive?id=${ this.state.subdomain }.${ this.host }`);
            if (error)
                throw new Error(message);
            this.state.institution = institution;
        } catch (error) {
            console.log('Check Institution Error: ', error);
            this.state.error = error.message;
        }
        this.state.searching = false;
    },
    checkExistingInstitution: async function () {
        try {
            const {error, message, institution} = await Request(`/institution/retreive?id=${ this.state.user.email }`);
            if (error)
                return;
            this.state.institution = institution;
        } catch (error) {
            console.log('Check Institution Error: ', error);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Welcome.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    AuthBackground_template = require("../components/AuthBackground.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    AuthBackground_tag = marko_loadTag(AuthBackground_template),
    Image_template = require("../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    TenantLogo_template = require("../../components/TenantLogo/index.marko"),
    TenantLogo_tag = marko_loadTag(TenantLogo_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Bx_template = require("../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Preloader_template = require("../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Footer_Public_template = require("../components/Footer-Public.marko"),
    Footer_Public_tag = marko_loadTag(Footer_Public_template),
    Wrapper_template = require("../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        "class": "position-fixed px-3 py-2"
      },
    marko_attrs1 = {
        "class": "d-flex height-100vh justify-content-center align-items-center center animated fast fadeIn"
      },
    marko_attrs2 = {
        "class": "d-inline-flex align-items-center"
      },
    marko_attrs3 = {
        "class": "text-right m-0"
      },
    marko_attrs4 = {
        "class": "p-2 col-xl-4 col-lg-5 col-md-6 col-10"
      },
    marko_attrs5 = {
        "class": "card-content"
      },
    marko_attrs6 = {
        "class": "card-body"
      },
    marko_attrs7 = {
        "class": "mx-50"
      },
    marko_attrs8 = {
        "class": "my-4"
      },
    marko_attrs9 = {
        "class": "font-medium-1 py-75"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("dc34dc"),
    marko_node0 = marko_createElement("br", null, "37", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "38", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("div", {
        "class": "col-3 text-center pr-0"
      }, "16", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("span", {
          "class": "text-muted font-medium-5"
        }, null, null, 1)
        .t("https://"),
    marko_attrs10 = {
        "class": "col",
        style: "padding-right:0"
      },
    marko_attrs11 = {
        "class": "col-5 pl-0"
      },
    marko_attrs12 = {
        "class": "font-medium-5"
      },
    marko_attrs13 = {
        "class": "col"
      },
    marko_attrs14 = {
        "class": "col-3 text-center"
      },
    marko_attrs15 = {
        "class": "col"
      },
    marko_attrs16 = {
        "class": "col-2"
      },
    marko_attrs17 = {
        "class": "font-medium-3"
      },
    marko_node3 = marko_createElement("br", null, "33", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs18 = {
        "class": "text-primary font-small-3 mt-2"
      },
    marko_attrs19 = {
        "class": "btn btn-outline-primary btn-xl text-left w-100 mt-4"
      },
    marko_attrs20 = {
        "class": "font-medium-1 mx-50 mt-4"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      scroll: true,
      renderBody: function(out) {
        AuthBackground_tag({}, out, __component, "1");

        out.be("div", marko_attrs0, "2", component);

        if (state.user) {
          out.be("div", marko_attrs2, "3", component);

          Image_tag({
              alt: "Image",
              src: state.user.photo || "/images/default/user.png",
              style: "width:50px;height:50px",
              class: "avatar mx-2"
            }, out, __component, "4");

          out.e("h5", marko_attrs3, "5", component, 1)
            .t(getFullname(state.user), component);

          out.ee();
        } else {
          TenantLogo_tag({}, out, __component, "6");
        }

        out.ee();

        out.be("section", marko_attrs1, "7", component);

        Row_tag({
            class: "w-100 d-flex justify-content-center",
            renderBody: function(out) {
              out.be("div", marko_attrs4, "9", component);

              out.be("div", marko_attrs5, "10", component);

              out.be("div", marko_attrs6, "11", component);

              out.be("div", marko_attrs7, "12", component);

              out.be("h5", marko_attrs8, "13", component);

              Locale_tag({
                  text: "Find your institution"
                }, out, __component, "14");

              out.ee();

              out.e("div", {
                  "class": marko_classValue("form-row d-flex align-items-center theme-bg-transparent rounded border " + (state.activeInput ? "shadow" : ""))
                }, "15", component, 3, 1)
                .n(marko_node2, component)
                .e("div", marko_attrs10, "18", component, 1)
                  .e("input", {
                      id: "search-input",
                      "class": "form-control form-control-xl font-medium-5 text-right border-none pr-0",
                      value: state.subdomain
                    }, "19", component, 0, 0, {
                      onblur: __component.d("blur", "onActiveInput", false, [
                          false
                        ]),
                      onfocus: __component.d("focus", "onActiveInput", false, [
                          true
                        ]),
                      onkeyup: __component.d("keyup", "onKeywords", false)
                    })
                .e("div", marko_attrs11, "20", component, 1)
                  .e("span", marko_attrs12, "21", component, 2)
                    .t(".")
                    .t(component.host, component);

              out.be("p", marko_attrs9, "22", component);

              if (state.error) {
                Locale_tag({
                    text: state.error,
                    class: "text-warning"
                  }, out, __component, "23");
              } else if (!state.subdomain) {
                Locale_tag({
                    renderBody: function(out) {
                      out.t("Enter the domain of your institution.");
                    }
                  }, out, __component, "24");
              }

              out.ee();

              if (state.institution) {
                Row_tag({
                    class: "mx-0 my-1",
                    renderBody: function(out) {
                      out.be("div", marko_attrs13, "26", component);

                      out.be("a", {
                          href: "//" + state.institution.domain
                        }, "27", component);

                      Row_tag({
                          class: "d-flex align-items-center border rounded py-25",
                          renderBody: function(out) {
                            out.be("div", marko_attrs14, "29", component);

                            Image_tag({
                                alt: "Image",
                                src: state.institution.logo || "/images/default/institution.png",
                                icon: "bx bx-buildings",
                                style: "width:55px;height:55px",
                                class: "round my-25"
                              }, out, __component, "30");

                            out.ee();

                            out.e("div", marko_attrs15, "31", component, 3)
                              .e("span", marko_attrs17, "32", component, 1)
                                .t(state.institution.name, component)
                              .n(marko_node3, component)
                              .e("span", marko_attrs18, "34", component, 1)
                                .t(state.institution.domain, component);

                            out.be("div", marko_attrs16, "35", component);

                            Bx_tag({
                                type: "right-arrow-alt",
                                class: "font-large-1 float-right"
                              }, out, __component, "36");

                            out.ee();
                          }
                        }, out, __component, "28");

                      out.ee();

                      out.ee();
                    }
                  }, out, __component, "25");
              }

              out.n(marko_node0, component);

              out.n(marko_node1, component);

              out.be("button", {
                  disabled: state.searching,
                  "class": "btn btn-primary btn-xl text-left w-100"
                }, "39", component, null, 0, {
                  onclick: __component.d("click", "onSearch", false)
                });

              if (state.searching) {
                Preloader_tag({
                    class: "float-right font-medium-5",
                    active: true
                  }, out, __component, "40");
              } else {
                Bx_tag({
                    type: "right-arrow-alt",
                    class: "font-large-1 float-right white-text"
                  }, out, __component, "41");
              }

              Locale_tag({
                  text: state.searching ? "Searching..." : "Search"
                }, out, __component, "42");

              out.ee();

              if (state.user) {
                out.be("button", marko_attrs19, "43", component, null, 0, {
                    onclick: __component.d("click", () => navigate('/onboarding'), false)
                  });

                Bx_tag({
                    type: "right-arrow-alt",
                    class: "font-large-1 float-right"
                  }, out, __component, "44");

                Locale_tag({
                    text: "Create institution"
                  }, out, __component, "45");

                out.ee();
              }

              out.ee();

              if (!state.user) {
                out.be("div", marko_attrs20, "46", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Don't have an account?");
                    }
                  }, out, __component, "47");

                out.t(" ");

                route_link_tag({
                    href: "/signup",
                    class: "text-secondary",
                    renderBody: function(out) {
                      Locale_tag({
                          text: "Sign Up",
                          class: "font-medium-1"
                        }, out, __component, "49");
                    }
                  }, out, __component, "48");

                out.ee();
              }

              out.ee();

              out.ee();

              out.ee();
            }
          }, out, __component, "8");

        out.ee();

        Footer_Public_tag({}, out, __component, "50");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
